import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, Cell, DialogContainer, Grid, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import TableRow from '../component/TableRow';
import instructorStyles from '../css/instructorStyles.css.js';
import styles from '../css/styles.css.js';


let admin = {
    admin_name: '',
    admin_id: '',
    admin_first_name:'',
    admin_last_name: ''
}
export default class Admins extends Component {

    constructor(props){
        super(props);
        this.state = {
          admins: [],
          temp_admin: admin,
          temp_id: '',
          visible: false,
          addMode : true,
          temp_new_admin: admin,
          newVisible: false,
        };


        this.deleteAdmin = this.deleteAdmin.bind(this);
        this.addAdmin = this.addAdmin.bind(this);
        this.changeAdminName = this.changeAdminName.bind(this);
        this.updateAdmin = this.updateAdmin.bind(this);
        this.changeAdminFirstName = this.changeAdminFirstName.bind(this);
        this.changeAdminLastName = this.changeAdminLastName.bind(this);
        this.changeNewAdminName = this.changeNewAdminName.bind(this);

    }

    componentWillUpdate()
    {
      console.log("componentWillUpdate");
        this.addBreadCrumbs();
    }

    
        addBreadCrumbs = () =>
        {
          console.log("Sections AddBreadCrumbs");
          this.props.replaceBreadCrumb([
            {
                "name":"Settings",
                "type":"",
                "onclickPath":"SettingsPage"
            },
            {
                "name":"All Adminsistrators",
                "type":"",
                "onclickPath":"admins"
            }
            ]);
        }    

    componentWillMount(){
        ApiRequestService({
            method: 'post',
            url: '/getAllAdmins'

        })
        .then(res => {
            console.log(res.data.data.admin_names);
            this.setState({
                admins: res.data.data.admin_names

            });


        })

    }


    addAdmin(){
        console.log("Add Admin :" + this.state.temp_new_admin.admin_name);
        const payload = {
            admin_name: this.state.temp_new_admin.admin_name
        }
        ApiRequestService({
            method: 'post',
            url:  '/addAdmin',
            data: payload

        })

        .then(res => {
            console.log("Add Admin response : ",res);
            let admins = [];
            if(this.state.admins){
                admins = this.state.admins;
            }
            if(res.data.status === 1){
              NotificationManager.error(res.data.message,'Error - User Not Found',10000);
              this.newHide()
              return
            }
            else if (res.data.data !== undefined && res.data.data !== null){
              admins.push({
                    admin_name:  res.data.data.admin_name,
                    admin_id: res.data.data.admin_id,
                    admin_first_name:  res.data.data.admin_first_name,
                    admin_last_name:  res.data.data.admin_last_name,
              });
            }
            this.setState({
                admins: admins
            })
            this.newHide()
        })


    }

    editAdmin(id){


        this.setState({
            temp_admin: this.state.admins[id] ,
            temp_id: id,
            addMode: false
        })
        this.show()
    }

    updateAdmin(){
        console.log("Editing subject :"  + this.state.temp_admin.admin_id);

        const payload = this.state.temp_admin

        ApiRequestService({
            method: 'post',
            url:  '/updateAdmin',
            data: payload

        })

        .then(res => {
            console.log(res);
            console.log("UpdateAdmin State: ",this.state.admins);
            this.setState({
                admins: this.state.admins,
                temp_admin: admin
            })
            this.hide()
        })


    }

    deleteAdmin(id){
        console.log("Deleting admin i:" + id +" id: " + this.state.admins[id].admin_id);
        const payload = {
            admin_id: this.state.admins[id].admin_id,
            admin_name: this.state.admins[id].admin_name
        }
        ApiRequestService({
            method: 'post',
            url:  '/deleteAdmin',
            data: payload

        })

        .then(res => {
            console.log(res);
            //window.localtion.reload();
             this.state.admins.splice(id,1)
            console.log("Spliced Array",this.state.admins);
           this.setState({
            admins: this.state.admins
           })
        })


    }
    changeNewAdminName(event) {
        let temp_admin_local =   this.state.temp_new_admin;
        temp_admin_local.admin_name =  event
        this.setState({
            temp_new_admin: temp_admin_local
        });
    }

    changeAdminName(userId) {
        let temp_admin_local =   this.state.temp_admin;
        temp_admin_local.admin_name =  userId
        this.setState({
            temp_admin: temp_admin_local
        });
    }

    changeAdminFirstName(firstName) {
        let temp_admin_local =   this.state.temp_admin;
        temp_admin_local.admin_first_name =  firstName
        this.setState({
            temp_admin: temp_admin_local
        });
    }

    changeAdminLastName(lastName) {
        let temp_admin_local =   this.state.temp_admin;
        temp_admin_local.admin_last_name =  lastName
        this.setState({
            temp_admin: temp_admin_local
        });
    }

    

    newShow = () => {
        this.setState({ temp_new_admin :admin, newVisible: true });
      };
    
    newHide = () => {
        this.setState({  newVisible: false,visible:false});
    };

    show = () => {
        this.setState({ visible: true });
      };

    hide = () => {
        this.setState({  newVisible: false, visible:false,
        addMode: true });
    };
    instPage(){
        browserHistory.push('/admins')
    }

    delete (id) {
        if (this.state.admins[id].admin_id === 1 || this.state.admins[id].admin_id === 2) {
            return;
        }
        else {
            confirmAlert({
                title: 'Are you sure want to delete this admin?',
                message: 'Press Confirm to submit',
      
                cancelLabel: 'Confirm',
                confirmLabel: 'Cancel',
                onCancel: () => this.deleteAdmin(id)
              })
        }
      };

    render() {

        let button = null;
        if(this.state.addMode){
            button = <Button style= {styles.addButton} onClick = {this.addAdmin}>Add Admin</Button>
        }
        else{
            button = <Button style= {styles.addButton} onClick = {this.updateAdmin}>Update Admin</Button>
        }
        var cancelButton = <Button style= {styles.cancelButton} onClick = {this.hide}>Cancel</Button>

        const actions = [];
        actions.push(button);
        actions.push(cancelButton);

        return (
            [<Grid gutter={0}   key="AdminTableGrid">
                <Cell size={12} style={instructorStyles.instructorTitle}>
                    Administrator
                    <Button
                        style={{float: "right"}}
                        className="archive-button" primary raised
                        onClick = {this.newShow}>
                    Add a New Admin
                    </Button>
                </Cell>
                <Cell size={12}>
                <table style={instructorStyles.instructorTable}>
                        <thead style={instructorStyles.thead} >
                            <tr>
                            <th>ID</th>
                            <th>USER ID</th>
                            <th>First NAME</th>
                            <th>LAST NAME</th>
                            <th>Actions</th>
                            </tr>

                        </thead>

                        <tbody>

                            {this.state.admins?this.state.admins.map((admin, i) => <TableRow key = {admin.admin_id}
                            data = {admin}
                            id = {admin.admin_id}
                            name = {admin.admin_name}
                            title = {"Admins"}
                            type = {"AdminsList"}
                            onEditClick = {() =>this.editAdmin(i)}
                            pushId ={"admin"}
                            onDeleteClick = {() =>this.delete(i)} />):null}
                        </tbody>
                    </table>
                </Cell>
            </Grid>,
            <DialogContainer
                        id="simple-action-dialog"
                        visible={this.state.newVisible}
                        onHide={this.newHide}
                        actions={actions}
                        //title="New Instructor"
                        width="500px"
                        key="AddAdminDialog"
                        >
                <h2><label for="adminId">New Administrator</label></h2>
{/*                 <input type="text"
                        id="adminId"
                        name="admin_name"
                        //defaultValue  = {this.state.temp_new_instructor.instructor_name}
                        onChange = {this.changeNewAdminName}
                        style={instructorStyles.dialogText}
                /> */}
                <TextField 
                        onChange = {this.changeNewAdminName}
                        id="adminId"
                        name="admin_name" 
                        placeholder="Enter the name of administrator" 
                        className="md-cell md-cell--12" 
                        required
                />
            </DialogContainer>,
            <DialogContainer
                        id="simple-action-dialog"
                        visible={this.state.visible}
                        onHide={this.hide}
                        actions={actions}
                        //title="New Instructor"
                        width="500px"
                        key="AddAdminDialog"
                        >
                <h2><label for="adminId">Update Administrator</label></h2>
                <TextField 
                    value={this.state.temp_admin.admin_name} 
                    onChange={this.changeAdminName} 
                    id="adminId" 
                    label="User Id" 
                    placeholder="Enter the User Id..." 
                    className="md-cell md-cell--12" 
                />
                <TextField 
                    value={this.state.temp_admin.admin_first_name} 
                    onChange={this.changeAdminFirstName} 
                    id="adminId" 
                    label="First Name" 
                    placeholder="Enter the First Name of the User..." 
                    className="md-cell md-cell--12" 
                />
                <TextField 
                    value={this.state.temp_admin.admin_last_name} 
                    onChange={this.changeAdminLastName} 
                    id="adminId" 
                    label="Last Name" 
                    placeholder="Enter the Last Name of the User..." 
                    className="md-cell md-cell--12" 
                />
                </DialogContainer> ]

        );
     }
}